export const discountData = [
  {
    id:"1",
    Name: "Weekend Deal",
    Value: "70 (Percentage)",
    DiscountPlan: "Standard",
    Valitidy: "22 May 2025 - 24 Jun 2025",
    Days: "Sat,Sun",
    Products: "All Products",
    Status: "Active",
  },
  {
    id:"2",
    Name: "Loyalty Reward",
    Value: "40 (Flat)",
    DiscountPlan: "Membership",
    Valitidy: "16 Apr 2025 - 16 May 2025",
    Days: "Mon,Tue,Thu,Fri",
    Products: "Specific Products",
    Status: "Active",
  },
  {
    id:"3",
    Name: "Flash Sale",
    Value: "60 (Percentage)",
    DiscountPlan: "Standard",
    Valitidy: "20 Mar 2025 - 20 Apr 2025",
    Days: "Thu,Fri,Sat,Sun",
    Products: "All Products",
    Status: "Active",
  },
  {
    id:"4", 
    Name: "Super Saver",
    Value: "80 (Percentage)",
    DiscountPlan: "Standard",
    Valitidy: "15 Feb 2025 - 15 Apr 2025",
    Days: "Mon,Tue,Wed",
    Products: "All Products",
    Status: "Active",
  },
  {
    id:"5",
    Name: "Surprise Savings",
    Value: "50 (Flat)",
    DiscountPlan: "Standard",
    Valitidy: "24 Jan 2025 - 24 Mar 2025",
    Days: "Mon,Tue,Thu,Sat",
    Products: "Specific Products",
    Status: "Active",
  },
];
